const
  DOM = {
    // DOM elements
    'html': document.querySelector('html')
  },
  pages = {
    "app": DOM.html.querySelector('.main-page')
  },
  platform = {
    "browser": () => {
      var ua = navigator.userAgent, tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return {name: 'IE', version: (tem[1] || '')};
      }
      if (M[1] === 'Chrome') {
        tem = ua.match(/\bOPR|Edge\/(\d+)/)
        if (tem != null) {
          return {name: 'Opera', version: tem[1]};
        }
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) {
        M.splice(1, 1, tem[1]);
      }
      return {
        name: M[0],
        version: M[1],
        isOldSafari: M[0] === 'Safari' && M[1] < 14 ? true : null
      }
    },
    "mobile": {
      "iOS": navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform),
      "iPadOS": navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1,
      "android": navigator.userAgent.match(/Android/i)
    }
  },
  globals = {
    "isLoaded": false,
    "userAgent": navigator.userAgent,
    "hasTouchScreen": () => {
      // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent
      if ("maxTouchPoints" in navigator) {
        return navigator.maxTouchPoints > 0;
      } else if ("msMaxTouchPoints" in navigator) {
        return navigator.msMaxTouchPoints > 0;
      } else {
        const mQ = window.matchMedia && matchMedia("(pointer:coarse)");

        if (mQ && mQ.media === "(pointer:coarse)") {
          return !!mQ.matches;
        } else if ('orientation' in window) {
          return true; // deprecated, but good fallback
        } else {
          // Only as a last resort, fall back to user agent sniffing
          return (
            /\b(BlackBerry|webOS|iPhone|IEMobile)\b/i.test(globals.userAgent) ||
            /\b(Android|Windows Phone|iPad|iPod)\b/i.test(globals.userAgent)
          );
        }
      }
    }
  }

export {DOM, globals, pages, platform}
